import CreateEditor from "./CreateEditor";

export default CreateEditor;